<script>
    export let options;

    import {createEventDispatcher} from 'svelte';

    import OrganizationsService from "../services/organizations.service";

    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    let selectedMonthIndex;

    const dispatch = createEventDispatcher();

    function monthChanged() {
        dispatch('monthChanged', {
            month: selectedMonthIndex
        });
    }

    function selectMonth(month) {
        selectedMonthIndex = month;
        jQuery('#changeMonthConfirmation').modal('show');
    }

    async function updateMonth() {
        const result = await OrganizationsService.updateRollingMonth(selectedMonthIndex, options.org.id);
        if (result && result.data) {
            options.org = result.data;
            monthChanged();
            jQuery('#changeMonthConfirmation').modal('hide');
        }
    }
</script>

<div class="modal fade" id="changeMonthConfirmation" tabindex="-1" role="dialog"
     aria-labelledby="changeMonthConfirmationday"
     aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Modifying the rolling months will affect pipeline to quota ratio report data.</p>
                <p>Please confirm to update the rolling months to <b
                        class="text-primary">{selectedMonthIndex}</b> for <b
                        class="text-primary">{options.org.name}</b>?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => updateMonth()}>
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<div class="col-md-2 mt-3 pr-0">
    <div class="dropdown" id="rolling-month-selector">
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownRollingMonth"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Next { options.org.ptqr_rolling_months } Month{ (options.org.ptqr_rolling_months != 1 ? 's' : '')}
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownRollingMonth">
            {#each months as month}
                <button on:click={ () => selectMonth(month) } class="dropdown-item">
                    Next {month} Month{ (month != 1 ? 's' : '')}
                </button>
            {/each}
        </div>
    </div>
</div>
